const styles = theme => ({
    listPanel: {
        marginBottom: 150
    },
    pageContainer: {
        background: theme.palette.background.paper
    }
});

export default styles;